import React from "react";
import {
  GNBContainer,
  LeftSection,
  SearchGroup,
  Divider,
  RightSection,
  SettingsGroup,
  AuthButtonsWrapper,
  MobileCategoryMenu,
} from "./styles";
import Logo from "./Logo";
import SearchBar from "./SearchBar";
import CategoryMenu from "./CategoryMenu";
import CurrencySelector from "./CurrencySelector";
import LanguageSelector from "./LanguageSelector";
import AuthButtons from "./AuthButtons";
import UserProfile from "./UserProfile";
import { useToken } from "@app/hooks";

interface NewGNBProps {
  hideUserProfile?: boolean;
}

const NewGNB: React.FC<NewGNBProps> = ({ hideUserProfile = false }) => {
  const { data: token } = useToken();
  const isLoggedIn = !!token;

  return (
    <GNBContainer>
      <LeftSection>
        <Logo />
        <Divider />
        <SearchGroup>
          <CategoryMenu />
          <SearchBar />
        </SearchGroup>
      </LeftSection>

      <RightSection>
        {/* Mobile: Show CategoryMenu on the right (hidden on desktop) */}
        <MobileCategoryMenu>
          <CategoryMenu />
        </MobileCategoryMenu>
        <SettingsGroup>
          <CurrencySelector />
          <LanguageSelector />
        </SettingsGroup>
        {!hideUserProfile && <Divider />}
        {!hideUserProfile && isLoggedIn ? (
          <UserProfile />
        ) : !hideUserProfile && !isLoggedIn ? (
          <AuthButtonsWrapper>
            <AuthButtons />
          </AuthButtonsWrapper>
        ) : null}
      </RightSection>
    </GNBContainer>
  );
};

export default NewGNB;
